import GeneralPageBody from './general-page-body';

export default GeneralPageBody;
